import React, { ReactElement, useState } from 'react';
import styles from './PromiseAwareButton.module.scss';

export type PromiseAwareButtonProps = {
  onclick: () => Promise<unknown>;
  className?: string;
  buttonText: string;
  onSuccess?: () => void;
  onError?: () => void;
  onLoading?: () => void;
  icon?: ReactElement<SVGElement>;
  disabled?: boolean;
};

export const PromiseAwareButton: React.FC<PromiseAwareButtonProps> = ({
  onclick,
  className,
  buttonText,
  onSuccess,
  onError,
  onLoading,
  icon,
  disabled,
}) => {
  const [loading, setLoading] = useState(false);

  const fetchData = () => {
    setLoading(true);
    onLoading?.();
    onclick()
      .then(() => {
        setLoading(false);
        onSuccess?.();
      })
      .catch(() => {
        setLoading(false);
        onError?.();
      });
  };

  return (
    <button
      className={className}
      onClick={fetchData}
      disabled={loading || disabled}
    >
      <div className={styles.itemsWrapper}>
        {icon}
        <span>{buttonText}</span>
      </div>
    </button>
  );
};
